import getEnv from "../tools/get-env";

/**
 * Logto SDK configuration for monitor-ui.
 *
 * Values are pulled from the same window._env_ runtime injection
 * scheme used elsewhere in the app (build-env.js + env-config.js),
 * with sensible local-dev fallbacks.
 *
 * The scope list deliberately mirrors admin-ui's `roles +
 * offline_access` baseline so we always receive the role claim used by
 * monitor-api to gate things like the admin-side InviteUserToSubscription
 * path, and so refresh tokens are issued for silent renewal.
 */

const FALLBACK_ENDPOINT = "https://3a1xkw.logto.app";
const FALLBACK_APP_ID = "5ri656u0tdput5spp5ogj";
const FALLBACK_RESOURCE = "https://api.rare.consulting";

const REQUIRED_SCOPES = ["openid", "profile", "email", "roles", "offline_access"];

/**
 * Resolve a runtime env value, treating empty string and the literal
 * "undefined" string as missing. Older builds of env-config.js (pre
 * build-env.js fix) emitted `KEY: "undefined"` when the env var was
 * unset, which then looks truthy to `||` fallback chains downstream.
 * Belt-and-braces here so we don't have to trust the build script.
 */
const env = (key) => {
  const raw = getEnv(key);
  if (raw == null) return undefined;
  if (raw === "" || raw === "undefined") return undefined;
  return raw;
};

export const logtoConfig = {
  endpoint: env("LOGTO_ENDPOINT") || FALLBACK_ENDPOINT,
  appId: env("LOGTO_MONITOR_APP_ID") || FALLBACK_APP_ID,
  resources: [env("LOGTO_API_RESOURCE") || FALLBACK_RESOURCE],
  scopes: REQUIRED_SCOPES,
};

export const logtoApiResource = () => env("LOGTO_API_RESOURCE") || FALLBACK_RESOURCE;
